import ab1 from "../assets/ab1.jpg";
import ab2 from "../assets/ab2.jpg";
import ab3 from "../assets/ab3.jpg";
import ab4 from "../assets/ab4.jpg";
import ab5 from "../assets/ab5.jpg";
import ab6 from "../assets/ab6.jpg";
import ab7 from "../assets/ab7.jpg";
import ab8 from "../assets/ab8.jpg";

const profiles = [
  {
    name: "Sophia",
    description: "Charming smile, warm hugs, and unforgettable cozy moments.",
    image: ab1, 
  },
  {
    name: "Isabella",
    description: "Loves candlelight dinners, laughter, and endless cuddles.",
    image: ab2
  },
  {
    name: "Mia",
    description: "Sweet talks, romantic walks, and a heart full of love.",
    image: ab3
  },
  {
    name: "Olivia",
    description: "Brings sunshine, warmth, and sparks of passion everywhere.",
    image: ab4
  },
  {
    name: "Emma",
    description: "Playful spirit, soft kisses, and moments full of joy.",
    image: ab5
  },
  {
    name: "Ava",
    description: "Romantic soul, loves surprises and sharing sweet vibes.",
    image: ab6
  },
  {
    name: "Lily",
    description: "Gentle touch, dreamy eyes, and unforgettable nights.",
    image: ab7
  },
  {
    name: "Scarlett",
    description: "Bold heart, soft whispers, and everlasting memories.",
    image: ab8
  },
];

export default profiles;
